<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/newsletter.svg');
            background-position: top !important;
          "
        ></div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("subscribe_to_our_newsletter") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="pt-8">
      <div class="row disablerow align-items-start">
        <!-- Left Area -->
        <div
          class="col-xl-9 innercreatetraining subscription_news"
          v-if="news_subscription"
        >
          <!-- verification -->
          <div class="sto_newsletter_popup ev__popup">
            <img
              class="newsletter_v_arrow"
              src="/static/img/newsletter_v_arrow.svg"
              alt="arraow"
            />
            <h3 class="align_center">{{ $t("email_verification") }}</h3>
            <p class="nl_p1" v-html="$t('thank_u_for_subscrption')"></p>
            <b>{{ subscription.subscriptionMail }}</b>
            <v-card-actions class="">
              <v-btn
                @click="confirmSubscription"
                outlined
                depressed
                tile
                class="savebutton"
              >
                {{ $t("confirm_subscription") }}</v-btn
              >
              <v-btn
                @click="stayBack"
                outlined
                depressed
                tile
                class="cancelBtn"
              >
                {{ $t("back") }}</v-btn
              >
            </v-card-actions>
          </div>
        </div>

        <div class="col-xl-9 innercreatetraining subscription_news" v-else>
          <!-- verification -->
          <div class="sto_newsletter_popup">
            <img
              class="newsletter_v_arrow"
              src="/static/img/sub_bluetick.svg"
              alt="arraow"
            />
            <h3 class="align_center">{{ $t("email_verification") }}</h3>
           <p class="" v-html="$t('a_verification_mail_sent', { email: emailAddress })"></p>
            <p class="nl_p2">
              {{ $t("please_click_link_to_update") }}
            </p>
            <v-card-actions class="">
              <v-btn
                @click="cancelSubscription"
                outlined
                depressed
                tile
                class="savebutton"
              >
                {{ $t("browse_training_programs") }}</v-btn
              >
            </v-card-actions>
          </div>
        </div>
        <!-- Right Area -->
        <div class="col-xl-3 ml-1 px-0 pl-md-12 pl-lg-8 row pt-0 onlyContact">
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  data() {
    return {
      subscription: null,
      news_subscription: true,
      emailAddress: null,
    };
  },

  mounted() {
    const savedData = sessionStorage.getItem("subscriptionData");
    if (savedData) {
      this.subscription = JSON.parse(savedData);
    } else {
      this.$router.push("/subscription-module");
    }
  },
  methods: {
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    onFinally() {
      showLoadingCircle(false);
    },

    redirectToSearchPage() {
      const searchTerm = this.search;
      this.$router.push("/category-training?term=" + searchTerm);
    },
    confirmSubscription() {
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      var _this = this;
      this.$axios
        .post("api/newsletter/", this.subscription)
        .then(function (response) {
          _this.emailAddress = _this.subscription.subscriptionMail;
          sessionStorage.removeItem("subscriptionData");
          _this.news_subscription = false;
          // _this.$router.push("/categories");
        })
        .catch(_this.onError)
        .finally(() => {
          _this.onFinally();
        });
    },
    cancelSubscription() {
      sessionStorage.removeItem("subscriptionData");
      this.$router.push("/categories");
    },
    stayBack() {
      this.$router.push("/subscribe-module?stayData=true");
    },
  },
};
</script>
